import { clinic } from "@/mocks/clinic";
import { ReserveButton } from "./ReserveButton";
import { LineButton } from "./LineButton";

export default function MobileFixedCta() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] grid grid-cols-3 border-t border-background-50/15 bg-primary-700 pb-[env(safe-area-inset-bottom)] lg:hidden">
      <LineButton className="flex flex-col items-center justify-center gap-1 py-3 text-background-50 active:bg-background-50/10">
        <i className="ri-line-fill text-lg" aria-hidden />
        <span className="text-[11px]">LINE相談</span>
      </LineButton>
      <ReserveButton className="flex flex-col items-center justify-center gap-1 border-x border-background-50/15 bg-background-50 py-3 text-primary-700 active:bg-secondary-100">
        <i className="ri-calendar-check-line text-lg" aria-hidden />
        <span className="text-[11px] font-medium">WEB予約</span>
      </ReserveButton>
      <a
        href={clinic.telHref}
        className="flex flex-col items-center justify-center gap-1 py-3 text-background-50 active:bg-background-50/10"
      >
        <i className="ri-phone-line text-lg" aria-hidden />
        <span className="text-[11px]">電話</span>
      </a>
    </div>
  );
}